import { epsClient } from 'modules/api/eps-client'

/**
 * Sends an `employee_login` demo event to EPS.
 *
 * `epsClient` sends both the `Authorization` header (Cognito idToken) and the
 * `access_token` cookie (`withCredentials: true`), so the endpoint accepts it
 * via the cookie path in `DemoAccessTokenAuthGuard`.
 *
 * Errors are caught and swallowed — this is a best-effort monitoring call and
 * must never affect the user's session.
 */
export async function postDemoEmployeeLogin(clientPublicKey: string): Promise<void> {
  try {
    await epsClient.post(`/api/v1/customers/${clientPublicKey}/demo/events`, {
      type: 'employee_login',
    })
  } catch {
    // Best-effort — do not surface monitoring errors to the user.
  }
}
